import(/* webpackMode: "eager" */ "/vercel/path0/components/AppProvider.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/scripts/GoogleTagManager.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/shared/chatwoot/ChatwootFallback.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/shared/chatwoot/ChatwootWidget.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/TopLoader.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper.min.css");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/global.scss")